<template>
      <div id="anchor" style="">
        <!-- <div class="qrCode">
            <b title="二维码"></b>
            <div class="qr">
                <div id="code">
                    <ul>
                        <li><img alt="" src="@/assets/imgs/code_yun.png"></li>
                    </ul>
                </div>
            </div>
        </div>
        <div title="返回顶部" @click="toTop" class="ah" id="toTop" style="display: block;">返回顶部</div> -->
        <img alt="" src="@/assets/imgs/code_yun_2.png">
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: "anchorBox",
    data(){
        return{
           
        }
    },
    mounted() {
        $(".qrCode").hover(function () {
            $(this).addClass("qrHover");
            $(this).children("b").stop().css("background-color", "#D4D4D4").animate({
                    "backgroundColor": "#000000"
                },
                0,
                function () {
                    $(this).css({
                        "backgroundColor": "#000000"
                    });
                });
            $(this).closest(".qrCode").find(".qr").show();
        }, function () {
            $(this).removeClass("qrHover");
            $(this).children("b").stop().css("background-color", "#000000").animate({
                    "backgroundColor": "#D4D4D4"
                },
                0,
                function () {

                    $(this).css({
                        "backgroundColor": "#D4D4D4"
                    });
                });
            $(this).closest(".qrCode").find(".qr").hide();
        });
        $("#toTop,#message").hover(function () {
                $(this).removeClass("hover");
                $(this).stop().css("background-color", "#D4D4D4").animate({
                        "backgroundColor": "#0f820c"
                    },
                    0,
                    function () {
                        $(this).addClass("hover");
                        $(this).css({
                            "backgroundColor": "#0f820c",
                            "height": ""
                        });
                    });
            },
            function () {
                $(this).removeClass("hover");
                if ($(document).scrollTop() <= 0) {
                    if ($(this).attr("id") == "toTop") {
                        $(this).css("backgroundColor", "");
                    } else {
                        $(this).stop().css("backgroundColor", "");
                    }
                    return;
                }
                $(this).stop().animate({
                        "backgroundColor": "#D4D4D4"
                    },
                    0,
                    function () {
                        $(this).removeClass("hover");
                        $(this).css("backgroundColor", "");
                    });
            });
    },
    methods:{
        toTop() {
            $("html, body").animate({
                    scrollTop: 0
                },
                300);
        },
       
    }
}
</script>

<style scoped lang="scss">

/*锚点*/
#anchor {
    position: fixed;
    left: 50%;
    bottom: 24px;
    // width: 40px;
    width: 200px;
    height:270px;
    _position: absolute;
    margin-left: 600px;
    z-index: 11;
    img{
        width: 100%;
        height: 100%;
    }
}

#anchor .ah,
#anchor #message {
    display: block;
    width: 40px;
    height: 40px;
    text-indent: -2999px;
    cursor: pointer
}

#anchor .ah {
    display: none;
    border-bottom: 1px solid #FFFFFF;
    background-position: 8px -536px
}

#anchor .hover {
    background-color: #0F820C;
    background-position: 8px -619px
}

#anchor #message {
    background-position: 8px -576px
}

#anchor #message:hover {
    background-color: #0F820C;
    background-position: 8px -659px
}

#anchor #toTop,
#anchor #message,
.qrCode b {
    background-image: url("../../assets/imgs/ico.png");
    background-repeat: no-repeat;
}

/*二维码*/
.qrCode {
    width: 40px;
    zoom: 1;
}

.qrCode b {
    font-size: 12px;
    background-color: #D4D4D4;
    background-position: 8px -859px;
    width: 40px;
    height: 40px;
    display: block;
    border-bottom: 1px solid #FFF;
    background-color: #D4D4D4;
}

.qrCode .qr {
    display: none;
    position: absolute;
    top: -110px;
    left: -147px;
    overflow: hidden;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
}

#code {
    float: right;
    overflow: hidden;
}

.qrCode .qr img {
    width: 120px;
    height: 120px;
}

.qrHover b {
    background-color: #0F820C;
    background-position: 8px -914px;
    color: #000000;
}

.qrHover .qr {
    display: block;
}

.qrCode .qr ul {
    zoom: 1;
    overflow: hidden;
    background-color: #FFF;
    border: 3px solid #000000;
    color: #000000;
    padding: 10px;
    height: 145px;
}

.qrCode .qr li {
    float: left;
    width: 120px;
    line-height: 32px;
    font-family: 'Microsoft Yahei';
    font-size: 14px;
}

.qrCode .qr li.last {
    margin-right: 0;
}

</style>